import {
  makeLazyQueryHook,
  makeMutationHook,
  makeQueryHook,
} from "utils/apolloUtils";

import { PAYMENT_TERMINALS_QUERY } from "./queries";
import {
  PAYMENT_TERMINAL_CREATE_MUTATION,
  PAYMENT_TERMINAL_DELETE_MUTATION,
} from "./mutations";
import {
  PaymentTerminals,
  PaymentTerminalsVariables,
} from "./__generated__/queries";
import {
  PaymentTerminalCreate,
  PaymentTerminalCreateVariables,
  PaymentTerminalDelete,
  PaymentTerminalDeleteVariables,
} from "./__generated__/mutations";

export const usePaymentTerminalsQuery = makeQueryHook<
  PaymentTerminals,
  PaymentTerminalsVariables
>(PAYMENT_TERMINALS_QUERY);

export const usePaymentTerminalListLazyQuery = makeLazyQueryHook<
  PaymentTerminals,
  PaymentTerminalsVariables
>(PAYMENT_TERMINALS_QUERY);

export const usePaymentTerminalCreateMutation = makeMutationHook<
  PaymentTerminalCreate,
  PaymentTerminalCreateVariables
>(PAYMENT_TERMINAL_CREATE_MUTATION);

export const usePaymentTerminalDeleteMutation = makeMutationHook<
  PaymentTerminalDelete,
  PaymentTerminalDeleteVariables
>(PAYMENT_TERMINAL_DELETE_MUTATION);
